import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import ListTeaserHeadlineFont from '../../../Theme/Fonts/ListTeaserHeadline'
import TeaserInfo from '../../../TeaserInfo'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { BackgroundColorTypes } from '../../../Theme/Fonts/FontTypes'
import LinkProps from '../../../Link/LinkProps'
import SmallPodcastListTeaserImage from './Image'

export type SmallPodcastListTeaserProps = LinkProps &
    TestID & {
        /** the url of the image */
        imageUrl: string
        /** info for seo about alt */
        alt?: string
        /** the headline text which is displayed right next to the image */
        headlineText: string
        /** the date as a string when the podcast was published */
        published?: string
        /** a text which should show the episode number of the podcast */
        episode?: string
        /** the duration of the podcast */
        duration?: string
        /** the color of the background
         *
         * @defaultValue pearl
         * */
        backgroundColor?: BackgroundColorTypes
        /** href string to navigate to the provided url (web only) */
        href?: string
        /** the callback when the user presses on the teaser
         *
         * @TJS-type function
         * */
        onPress?: () => void
    }

const SmallPodcastListTeaser: FunctionComponent<SmallPodcastListTeaserProps> = ({
    imageUrl,
    alt,
    headlineText,
    published,
    episode,
    duration,
    backgroundColor = 'pearl',
    href,
    onPress,
    testID,
    webRel,
}): ReactElement | null => {
    return (
        <Touchable onPress={onPress} href={href} testID={testID} webRel={webRel}>
            <Grid
                horizontal
                centerVertical
                noExpand
                backgroundColor={backgroundColor}
                width="100%"
                paddingY={5}
            >
                <Grid horizontal marginX={5} minWidth={0} centerVertical>
                    <SmallPodcastListTeaserImage imageUrl={imageUrl} alt={alt} />
                    <Grid noExpand marginLeft={5} minWidth={0} evenly width="100%">
                        <ListTeaserHeadlineFont
                            color={backgroundColor === 'onyx' ? 'pearl-4' : 'onyx-5'}
                            numberOfLines={1}
                        >
                            {headlineText}
                        </ListTeaserHeadlineFont>
                        <TeaserInfo
                            name={episode}
                            published={published}
                            duration={duration}
                            hideTagImage
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Touchable>
    )
}

export default SmallPodcastListTeaser
